import { createSelector } from "reselect";
import getConditions from "./getConditions";
import { getProducts } from "./getProducts";

const getRegions = state => state.regions.data;
const getParameters = state => state.advisor;

const filteredResults = createSelector(
  [getConditions, getProducts, getRegions, getParameters],
  (conditions, products, regions, parameters) => {
    const enrichWithVideo = product => {
      const region = regions.find(region => region.id === parameters.region);
      const regionLanguage = region ? region.language : "en";
      const productVideo = product.videos.find(video => {
        return (
          video.sport_type_id === parameters.sportType &&
          video.language === regionLanguage
        );
      });

      return Object.assign({}, product, {
        video: productVideo ? productVideo.url : null
      });
    };

    if (conditions.length) {
      const selectedCondition = conditions[0];

      const layer1 = products.find(
        product => product.sku === selectedCondition.layer_1
      );

      const layer2 = products.find(
        product => product.sku === selectedCondition.layer_2
      );

      const layer3 = products.find(
        product => product.sku === selectedCondition.layer_3
      );

      return {
        layer1: layer1 ? enrichWithVideo(layer1) : null,
        layer2: layer2 ? enrichWithVideo(layer2) : null,
        layer3: layer3 ? enrichWithVideo(layer3) : null,
        protip: selectedCondition.protip
      };
    }

    return { layer1: null, layer2: null, layer3: null };
  }
);

export default filteredResults;
